module.exports = __webpack_public_path__ + "img/CHAT.8d401a97.svg";